import Box from '@mui/material/Box';

import { Button } from '../../index';

interface BaseFiltersButtonsProps {
  onResetClick: () => void;
}

function BaseFiltersButtons({ onResetClick }: BaseFiltersButtonsProps) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridAutoFlow: 'column dense',
        columnGap: '1rem',
        rowGap: '1rem',
        py: 2.5,
        justifyContent: 'end',
      }}
    >
      <Button onClick={onResetClick} variant="outlined">
        Reset Filters
      </Button>
      <Button type="submit" variant="contained">
        Apply Filters
      </Button>
    </Box>
  );
}

export default BaseFiltersButtons;
